import router from '../../router/router';

// 路由链接 Module 点击调转到某页面的 逻辑
const state = {
}
const mutations = {
}
const getters = {
}
const actions = {
  LinkToEx({rootGetters, dispatch,commit}, opt){  // 链接到展商
    const exhibitionId = rootGetters.getExhibitionId;
    
  },
}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
